import React from "react";
import { LocalBusinessJsonLd } from "next-seo";

const DefaultSeo = () => {
  return (
    <LocalBusinessJsonLd
      type="ToyStore"
      id="https://www.cubenationshop.com/"
      name="CubeNation"
      description=" Bangladesh Speed Cube collection and Twisty Puzzle Bazaar"
      url="https://www.cubenationshop.com/"
      telephone="+8809613750849"
      address={{
        streetAddress:
          "House #91-93, Road #W2 ,Block-C, Eastern Housing, Pallabi, Mirpur",
        addressLocality: "Dhaka",
        addressRegion: "Dhaka",
        postalCode: "1216",
        addressCountry: "BD",
      }}
      geo={{
        latitude: "23.8225628",
        longitude: "90.3527382",
      }}
      priceRange="$$"
      images={[
        "https://blog.cubenationshop.com/content/images/2022/06/canvas-9.6x12-2nd-.png",
        "https://blog.cubenationshop.com/content/images/size/w960/2022/06/CN-06--1-.jpg",
        "https://blog.cubenationshop.com/content/images/size/w960/2022/06/CN-05--1-.jpg",
      ]}
      sameAs={[
        "https://www.facebook.com/CubeNationBD",
        "https://www.instagram.com/cubenationshop",
        "https://www.linkedin.com/company/cubenation",
      ]}
      openingHours={[
        {
          opens: "10:00",
          closes: "19:59",
          dayOfWeek: [
            "Saturday",
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
          ],
          validFrom: "2022-12-23",
          validThrough: "2024-12-22",
        },
      ]}
      rating={{
        ratingValue: "5",
        ratingCount: "187",
      }}
      areaServed={[
        {
          geoMidpoint: {
            latitude: "23.8225628",
            longitude: "90.3527382",
          },
          geoRadius: "350000",
        },
      ]}
    />
  );
};

export default DefaultSeo;
